import React from "react";
import NativeSelect from '@material-ui/core/NativeSelect';


const renderDropdown = field => {
    const {
      meta: { touched, error },
      label,
      optionsData,
    } = field;
    const className = `form-control ${touched && error ? "is-invalid" : ""}`;
    return (
      <div className="form-group ">
        <label>{label}</label>
        <NativeSelect
          {...field.input}
          className={className}
          error={touched && error ? true : false}
        >
         {optionsData}
        </NativeSelect>
        <div className="invalid-feedback"> {touched ? error : ""}</div>
      </div>
    );
  };

export default renderDropdown;


// WEBPACK FOOTER //
// ./src/components/wizardSection/renderDropdown.jsx